<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator' :max-width = '$vuetify.breakpoint.smAndUp ? "75%": "95%"'>
        <template v-slot:title>{{user.name}} {{user.lastname}}</template>
        <template v-slot:content>
            <v-layout column>
                <v-tabs grow v-model = 'tab' :color = '$store.getters.uiAccent'>
                    <v-tabs-slider :color = '$store.getters.uiAccent' width='1'></v-tabs-slider>
                        <v-tab key='direct'>
                            <v-icon left>mdi-target-account</v-icon>Явные доступы
                        </v-tab>
                        <v-tab key='indirect'>
                            <v-icon left>mdi-account-convert</v-icon>Неявные доступы
                        </v-tab>
                </v-tabs>
                <v-tabs-items v-model = "tab">
                    <v-tab-item key='direct'>
                        <distinct-grants :grants = 'grants' :indicator = 'indicator'></distinct-grants>
                    </v-tab-item>
                    <v-tab-item key='indirect'>
                        <indistinct-grants :grants = 'grants' :indicator = 'indicator' :user = 'user'></indistinct-grants>
                    </v-tab-item>
                </v-tabs-items>
            </v-layout>
        </template>
    </dialog-generic>
</template>
<script>

    import DistinctGrants from '@/components/entities/users/grants/DistinctGrants.vue'
    import IndistinctGrants from '@/components/entities/users/grants/IndistinctGrants.vue'
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'Grants',
        props: ['data', 'initialState'],
        components: {DistinctGrants, IndistinctGrants, DialogGeneric},
        data() {
            return {
                tab: null,
                visibility: this.initialState,
                user: this.data,
                indicator: false,
                indicatorSecondary: false,
                visibilitySecondary: false,
                updating: false,
                grants: [],
                grant: {},
                defaultModes: [
                    { 'text': 'Чтение', 'value': 'R' },
                    { 'text': 'Изменение', 'value': 'W' },
                    { 'text': 'Удаление', 'value': 'X' },
                    { 'text': 'Полное управление', 'value': 'U' }
                ],
                modes: {
                    'X': 'Полный доступ',
                    'U': 'Создание и редактирование',
                    'W': 'Редактирование',
                    'R': 'Просмотр'
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            data(value) {
                this.user = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            user(value) {
                this.grants = []
                this.tab = 0
                if (Object.keys(value).length){
                    this.getUserGrants(0)
                }
            },
            tab(value) {
                if (Object.keys(this.user).length) {
                    this.getUserGrants(value)
                }
            }
        },
        methods: {
            getUserGrants(direct) {
                this.indicator = true;
                this.grants = []
                let requestData = {
                    'indirect': direct,
                    'user': this.user.uid,
                    'superuser': this.user.superuser,
                    'login': this.$store.getters.userLogin
                }
                this.$http.get(this.$store.getters.endpoint + '/db/person/grants', {
                    emulateJSON: true,
                    params: requestData,
                    headers: { ...this.$store.state.restrictedHeaders }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        if (!direct) {
                            this.grants = response.data.map((g) => {
                                return g.reports.map((r) => {
                                    return {
                                        project_name: g.project_name,
                                        mode_name: g.mode_name,
                                        r_name: r.name,
                                        r_mode_name: r.mode_name,
                                        r_mode_edit: r.mode_edit,
                                        r_mode_persons: r.mode_persons
                                    }
                                })
                            })
                            this.grants = this.grants.reduce((a, b) => { return a.concat(b) })
                        } else {
                            this.grants = response.data
                        }
                        this.indicator = false;
                    } else {
                        console.log(response)
                    }
                })
            }
        },
        computed: {
            projectSegments() {
                return this.$store.state.segments
            },
            projectVerticals() {
                return this.$store.state.verticals
            },
        },
        mounted() {
            this.$store.dispatch('fillSegments');
            this.$store.dispatch('fillVerticals');
            if (Object.keys(this.user).length) {
                this.getUserGrants(0)
            }
        }
    }
</script>